import {
  MaterialTraceability,
  AnatomyItem,
  ImplantItem,
  RemovableItem,
  Product,
} from "../types/interfaces";
import { ItemType } from "../types/enums";

export const getMaterialTraceabilityOfItem = (
  item: AnatomyItem | ImplantItem | RemovableItem,
  providerMaterialTraceability: MaterialTraceability[]
): MaterialTraceability[] => {
  return providerMaterialTraceability
    .filter(material => material.id && material.firstMaterialReference)
    .filter(material => {
      if (item.itemType === ItemType.INLAY_CORE) {
        return (
          material.itemMaterialId ===
          (item as AnatomyItem)?.inlayCoreMaterial?.id
        );
      }
      if (
        [
          ItemType.BLEACHING_TRAY,
          ItemType.RETAINER,
          ItemType.FULL_DENTURE_WAX_BITE,
        ].includes(item.itemType)
      ) {
        return material.itemMaterialId === item.itemType;
      }
      return material.itemMaterialId === item?.itemMaterial?.id;
    });
};

export const hasAtLeastOneMaterialTraceability = (
  products: Product[],
  providerMaterialTraceability: MaterialTraceability[]
): boolean => {
  return (products ?? []).some(product => {
    return (
      (product?.anatomyItem ?? []).some(item => {
        return (
          getMaterialTraceabilityOfItem(item, providerMaterialTraceability)
            .length > 0
        );
      }) ||
      (product?.implantItem ?? []).some(item => {
        return (
          getMaterialTraceabilityOfItem(item, providerMaterialTraceability)
            .length > 0
        );
      }) ||
      (product?.removableItem ?? []).some(item => {
        return (
          getMaterialTraceabilityOfItem(item, providerMaterialTraceability)
            .length > 0
        );
      })
    );
  });
};
